import CourseTab from './CourseTab';

export default CourseTab;
